export function getSalaryCalcCoefficient(contract) {
  const raw = contract?.salary_calc_percent
  if (raw != null && raw !== '' && !Number.isNaN(Number(raw))) {
    const percent = Number(raw)
    if (percent <= 0) return 1
    if (percent >= 100) return 1
    return 1 - percent / 100
  }
  if (contract?.staff_status === 'SELF_EMPLOYMENT') return 0.96
  return 0.94
}

export function grossFromNet(net, contract) {
  const netNum = Number(net) || 0
  return Math.round(netNum / getSalaryCalcCoefficient(contract))
}
